<template>
  <div>
    <!-- <div class="right-box">
      <div class="right-title">
        <span>热门公司</span>
      </div>
      <div class="company-box">
        <el-tabs v-model="activeName" @tab-click="handleClick">
          <el-tab-pane label="跨境电商" name="second">
            <div class="company">
              <el-link
                v-for="(list1, index) of list"
                :key="index"
                :href="'/enterprise/#/Inside?name=' + list1"
                target="_blank"
                >{{ list1 }}</el-link
              >
            </div>
          </el-tab-pane>
          <el-tab-pane label="产业电商" name="first">
            <div class="company">
              <el-link
                v-for="(list2, index) of list2"
                :key="index"
                :href="'/enterprise/#/Inside?name=' + list2"
                target="_blank"
                >{{ list2 }}</el-link
              >
            </div>
          </el-tab-pane>
          <el-tab-pane label="零售电商" name="fourth">
            <div class="company">
              <el-link
                v-for="(list3, index) of list3"
                :key="index"
                :href="'/enterprise/#/Inside?name=' + list3"
                target="_blank"
                >{{ list3 }}</el-link
              >
            </div>
          </el-tab-pane>
          <el-tab-pane label="数字生活" name="third">
            <div class="company">
              <el-link
                v-for="(list4, index) of list4"
                :key="index"
                :href="'/enterprise/#/Inside?name=' + list4"
                target="_blank"
                >{{ list4 }}</el-link
              >
            </div>
          </el-tab-pane>
          <el-tab-pane label="在线教育" name="fifth">
            <div class="company">
              <el-link
                v-for="(list5, index) of list5"
                :key="index"
                :href="'/enterprise/#/Inside?name=' + list5"
                target="_blank"
                >{{ list5 }}</el-link
              >
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div> -->

    <Email />

        <!-- <div class="right-box">
      <div class="right-title">
        <span>网经社数字生活台</span>
        <a href="http://DL.100ec.cn/" target="_blank"
          >更多</a
        >
      </div>
      <div style="width: 300px">
        <a href="http://DL.100ec.cn/" target="_blank">
          <img style="width: 100%" src="/Public/home/images/szsh550.jpg" />
        </a>
      </div>
    </div> -->


    <!-- <div class="right-box">
      <div class="right-title">
        <span>网经社数字零售台</span>
        <a href="http://DR.100ec.cn/" target="_blank"
          >更多</a
        >
      </div>
      <div style="width: 300px">
        <a href="http://DR.100ec.cn/" target="_blank">
          <img style="width: 100%" src="/Public/home/images/szls550.jpg" />
        </a>
      </div>
    </div> -->
    <div style="width: 365px">
        <a href="/detail--6659850.html" target="_blank">
          <img style="width: 100%" src="/Public/tuku/6a268b3659746.jpg" />
        </a>
      </div>
  </div>
</template>

<script>
export default {
  name: "ContentR",
  data() {
    return {
      activeName: "second",
      list: [
        "天猫国际",
        "京东国际",
        "考拉海购",
        "洋码头",
        "阿里国际站",
        "亚马逊全球开店",
        "eBay",
        "Wish",
        "全球速卖通",
        "SHEIN",
      ],
      list2: [
        "1688",
        "国联股份",
        "塑米城",
        "上海钢联",
        "焦点科技",
        "卓尔智联",
        "药易购",
        "生意宝",
        "科通芯城",
        "慧聪集团",
        "摩贝",
        "找钢网",
      ],
      list3: [
        "阿里巴巴",
        "京东",
        "拼多多",
        "小米集团",
        "快手",
        "苏宁易购",
        "唯品会",
        "叮咚买菜",
        "国美零售",
        "达达",
        "良品铺子",
        "微盟集团",
      ],
      list4: [
        "滴滴出行",
        "马蜂窝",
        "去哪儿",
        "BOSS直聘",
        "嘀嗒出行",
        "e代驾",
        "高德地图",
        "青桔单车",
        "曹操出行",
        "T3出行",
        "驴妈妈",
        "哈啰出行",
      ],
      list5: [
        "学而思",
        "作业帮",
        "掌门教育",
        "沪江网校",
        "学堂在线",
        "网易有道",
        "粉笔教育",
        "核桃编程",
        "一起教育",
        "云学堂",
        "火花思维",
        "小鹅通",
      ],
    };
  },
  created() {
    // this.$store.commit("getCompanyTabs", this.params);
  },
  mounted() {
    if (new Date().getMonth >= 2) {
      this.year = new Date().getFullYear();
    } else {
      this.year = new Date().getFullYear() - 1;
      this.time = "whole_year";
    }
    // axios
    //   .get(
    //     "http://www.315.100ec.cn/api/index.php?_a=product&f=most_company_list&type=" +
    //       this.$store.state.type +
    //       "&limit=20&year=" +
    //       this.year +
    //       "&time=" +
    //       this.time
    //   )
    //   .then((res) => {
    //     for (var i of res.data.list.slice(0, 10)) {
    //       this.platform.push(i.company);
    //     }
    //   });
  },
  methods: {
    handleClick(tab, event) {
      // console.log(tab, event);
    },
    getPlatform(index) {
      window.open(
        "/Index/complain_search.html?company=" + this.platform[index]
      );
    },
  },
};
</script>